import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Anchor from "../../objects/Anchor";

class WebinarItem extends Component {

    render() {
        const { webinar, index } = this.props;
        const image = webinar.image;
        
        return (
            <div className="col-12 col-md-6 col-xl-4 base-card webinar-card" key={ index }>
                <Anchor path={`/training/interactive-webinars/${ webinar.uid}`} anchorClass="card-inner" internal>
                    <div className="image" style={{backgroundImage: `url(${image})`}}></div>
                    <div className="theme-webinar-body">
                        <h3 className="heading-three">{webinar.title}</h3>
                        <p className="body-copy">{webinar.description}</p>
                    </div>
                </Anchor>
            </div>
        );
    };
}

WebinarItem.proptypes = {
    webinar: PropTypes.object.isRequired,
};

export default WebinarItem;



// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/cards/WebinarCard.js